<template>
  <div class="ma-2 mt-8">
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card flat v-else>
      <v-row>
        <v-col
          :cols="
            cardpack.length >= 4
              ? 'lg-3 xl-3 sm-3 xs-3 md-3'
              : 'lg-4 xl-4 sm-4 xs-4 md-4'
          "
          v-for="card in cardpack"
          :key="card.title"
        >
          <div dense v-if="card.pack_name != 'Enterprise'">
            <v-hover v-slot:default="{ hover }">
              <v-card
                height="auto"
                class="pb-10"
                :elevation="hover ? 10 : 4"
                :class="{ up: hover }"
                style="border: solid 1px rgba(10, 8, 2, 0.842)"
                rounded="xl"
              >
                <div
                  style="font-size: 17px; text-align: center; padding: 30px"
                  class="font-weight-bold ml-2"
                >
                  {{ card.pack_name }}
                </div>

                <div
                  style="
                    font-size: 14px;
                    font-weight: 600;
                    text-align: center;
                    padding: 20px;
                  "
                  v-if="
                    card.pack_name != ' ' &&
                    card.pack_name != 'ENTERPRISE' &&
                    card.pack_name != 'Enterprise' &&
                    card.pack_name != 'Promo '
                  "
                >
                  Monthly : MYR {{ card.mbilling_fee }}<br />
                  Annual : MYR {{ card.abilling_fee }}
                </div>
                <div
                  v-if="card.pack_name == 'Promo '"
                  align="center"
                  justify="center"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      class="mt-n2"
                    >
                      <v-icon large color="secondary"
                        >mdi-wallet-giftcard
                      </v-icon>
                    </v-col>
                  </v-row>
                  <br />
                </div>
                <div
                  style="
                    font-size: 28px;
                    font-weight: 600;
                    text-align: center;
                    padding: 20px;
                  "
                  v-if="
                    card.pack_name != '' &&
                    (card.pack_name == 'ENTERPRISE' ||
                      card.pack_name == 'Enterprise')
                  "
                >
                  Contact Us
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-text class="text--primary mt-n4 ml-1">
                  <div
                    v-if="card.pack_name == ' '"
                    class="text--primary mt-4 mb-2 ml-1"
                  >
                    For More than 50 cards and for customized Deals.
                  </div>

                  <v-list dense class="mt-4">
                    <v-expansion-panels flat inset v-if="card.pack_name != ' '">
                      <v-expansion-panel>
                        <v-expansion-panel-header v-slot="{ open }">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              xs="12"
                              md="10"
                              lg="10"
                              xl="10"
                              style="
                                font-size: 14px;
                                text-align: center;
                                margin-left: 40px;
                              "
                              class="font-weight-medium gold--text mt-n5"
                            >
                              Key Features
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              xs="12"
                              md="12"
                              lg="12"
                              xl="12"
                              class="text--secondary"
                            >
                              <v-fade-transition leave-absolute>
                                <span v-if="open"></span>
                                <v-row
                                  v-else
                                  no-gutters
                                  style="width: 100%"
                                  v-for="(item, i) in card.features"
                                  :key="i"
                                  class="mt-n4"
                                >
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    xs="12"
                                    md="12"
                                    lg="12"
                                    xl="12"
                                  >
                                    <div
                                      v-if="card.pack_name != 'Promo '"
                                      class="caption"
                                      align="center"
                                      justify="center"
                                    >
                                      {{ item }}
                                    </div>
                                    <div
                                      v-if="card.pack_name == 'Promo '"
                                      class="caption black--text"
                                      align="center"
                                      justify="center"
                                    >
                                      {{ item }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-fade-transition>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <!-- <span class="caption" align="left">
                        ● Personalized Glyd Cards
                      </span> -->
                          <div v-for="(item, i) in card.features" :key="i">
                            <v-row
                              cols="12"
                              sm="12"
                              xs="12"
                              md="12"
                              lg="12"
                              xl="12"
                            >
                              <v-col
                                cols="12"
                                sm="1"
                                xs="1"
                                md="1"
                                lg="1"
                                xl="1"
                              >
                                <div
                                  v-if="card.pack_name != 'Promo '"
                                  class="caption"
                                  align="left"
                                >
                                  ●
                                </div>
                                <div
                                  v-if="card.pack_name == 'Promo '"
                                  class="caption black--text"
                                  align="left"
                                >
                                  ●
                                </div></v-col
                              >
                              <v-col
                                cols="12"
                                sm="12"
                                xs="12"
                                md="10"
                                lg="10"
                                xl="10"
                              >
                                <div
                                  class="caption"
                                  align="left"
                                  v-if="card.pack_name != 'Promo '"
                                >
                                  {{ item }}
                                </div>
                                <div
                                  class="caption black--text"
                                  align="left"
                                  v-if="card.pack_name == 'Promo '"
                                >
                                  {{ item }}
                                </div></v-col
                              ></v-row
                            >
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-list>
                </v-card-text>
                <v-card-actions justify-center>
                  <v-row justify="center">
                    <v-btn
                      rounded
                      class="black--text ml-1 mt-n2 mb-2 btn1"
                      @click="openEGHLPage('0', card)"
                      v-if="card.pack_name == 'Promo '"
                      :disabled="
                        PendingRequestMSg == 'Request exists' || count == 1
                      "
                      :loading="btnloading"
                      >Order Now</v-btn
                    >
                    <v-btn
                      v-else
                      rounded
                      class="black--text ml-1 mt-n2 mb-2 btn1"
                      @click="openEGHLPage('0', card)"
                      :disabled="
                        PendingRequestMSg == 'Request exists' || count == 1
                      "
                      :loading="btnloading"
                      >Order Now</v-btn
                    >
                    <!-- <v-btn
                      rounded
                      class="black--text ml-1 mt-n2 mb-2 btn1"
                      @click="openEGHLPage('0', card)"
                      :disabled="
                        (card.pack_name == 'Silver' ||
                          card.pack_name == 'Bronze' ||
                          card.pack_name == 'Gold') &&
                        $store.getters.get_getCustDetails.is_purchase != 1
                      "
                      >Order Now</v-btn
                    > -->
                    <!-- v-if="
                      card.pack_name != 'Enterprise' &&
                      card.pack_name != 'Silver' &&
                      card.pack_name != 'Bronze' &&
                      card.pack_name != 'Gold'
                    " -->
                    <!--   card.pack_name != 'Bronze' &&
                    :disabled="
                      $store.getters.get_getCustDetails.is_purchase != 0 ||
                      PendingRequestMSg == 'Request exists'
                    "
                   -->
                    <v-btn
                      rounded
                      v-if="
                        card.pack_name == 'ENTERPRISE' ||
                        card.pack_name == 'Enterprise'
                      "
                      class="black--text ml-1 mt-n2 mb-2 btn1"
                      @click="getToconTact"
                      >Contact Us</v-btn
                    >
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-hover>
          </div>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogeSelectCard"
        transition="dialog-top-transition"
        max-width="550px"
        persistent
      >
        <v-card class="elevation-0">
          <v-toolbar dark class="header" dense>
            <v-icon>mdi-cards-playing-outline</v-icon>
            <span class="ml-3"
              >Pack Details - {{ this.packValue.pack_name }}</span
            >
            <v-spacer></v-spacer>
            <v-btn class text dark @click="coseSelectCard()">
              <v-icon color="white" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <div
            class="font-weight-bold text mt-3 mb-2 ml-5"
            style="font-size: 14px"
            v-if="paymenttextshow == 2"
          >
            Pack Details are Listed Below and Click Here to Credit Amount.
          </div>

          <v-card-text class="mt-6">
            <span
              style="font-size: 14px"
              class="mt-2"
              v-for="(item, i) in packValue.features"
              :key="i"
            >
              <div align="left" class="primary--text">
                <v-icon color="secondary" class="mt-n1" x-small
                  >mdi-star</v-icon
                >
                &nbsp;&nbsp;<b>{{ item }}</b>
              </div>
            </span>
            <br />
            <div v-if="packValue.pack_name != 'Promo '">
              <b class="primary--text mb-1">Pricing :</b>
              <br />
              <span style="font-size: 14px" class="mt-2">
                ● Monthly Billing Fee - MYR {{ this.packValue.mbilling_fee }}
              </span>
              <br />

              <span style="font-size: 14px" class="mt-2">
                ● Annual Billing Fee - MYR {{ this.packValue.abilling_fee }}
              </span>
              <br />
            </div>
            <v-divider class="mt-2 mb-2"></v-divider>
            <div v-if="paymenttextshow == 1 || paymenttextshow == 2">
              <span style="font-size: 16px" class="mb-2">
                <b class="primary--text">Your Corporate Balance :</b>
                MYR {{ $store.getters.get_getCustDetails.funding_balance }}
              </span>
            </div>
            <div v-if="paymenttextshow == 1" class="mt-4">
              <span style="font-size: 16px" class="grey--text">
                <b>Pack Price</b>
                <b class="red--text ml-2 mr-2"
                  >MYR {{ this.packValue.abilling_fee }}</b
                >
                <b>Will Be Debited From Your Corporate Balance and </b>
                <b>{{ this.packValue.no_of_cards }} </b
                ><b>Card(s) will be Credited to your Account.</b>
              </span>
              <br /><br />
              <span style="font-size: 16px" class="primary--text">
                Click on
                <b class="primary--text">CONFIRM</b> to proceed.
              </span>
            </div>
            <div v-if="paymenttextshow == 2">
              <div class="text">
                <span style="font-size: 16px">
                  <b class="font-weight-bold red--text"
                    >Insufficient Corporate Balance.</b
                  >
                </span>

                <br />
                <span style="font-size: 16px" class="primary--text">
                  To Credit amount to your Corporate balance.
                  <b
                    style="font-size: 16px"
                    class="font-weight-bold blue--text cursor"
                    @click="routetofundings"
                    >Click Here!</b
                  >
                </span>
              </div>
            </div>
            <div
              style="font-size: 16px"
              class="font-weight-bold primary--text"
              v-if="paymenttextshow == 0"
            >
              Click on below to pay from your registered bank account
            </div>
            <v-radio-group v-model="row" row style="font-size: 14px">
              <br />

              <v-radio
                v-if="paymenttextshow == 0 && packValue.pack_name != 'Promo '"
                class="mt-n2"
                label="Pay Now For Annual Billing Fee "
                value="DD"
              ></v-radio>
              <v-radio
                v-if="paymenttextshow == 0 && packValue.pack_name == 'Promo '"
                class="mt-n2"
                label="Pay Now"
                value="DD"
              ></v-radio>

              <span
                style="font-size: 16px; margin-top: -5px"
                v-if="paymenttextshow == 0"
              >
                <b class="font-weight-bold grey--text ml-n2">
                  - MYR &nbsp;{{ this.packValue.abilling_fee }}</b
                >
              </span>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="mt-n2">
            <v-spacer></v-spacer>
            <v-btn
              class="mt-n2"
              color="primary"
              v-if="paymenttextshow == 1"
              @click="submit()"
              >Confirm</v-btn
            >
            <v-btn
              class="mt-n2"
              color="primary"
              v-if="row != null && paymenttextshow == 0"
              @click="openEGHLPage('1')"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="submitDialoge" width="400" persistent>
        <v-card class="overflow-hidden">
          <v-toolbar class="elevation-0" dense>
            <span> Are you sure you want to submit ? </span>
            <v-spacer></v-spacer>
            <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
          </v-toolbar>
          <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-row class="mt-2" style="margin-left: 200px">
              <v-btn
                text
                width="90px"
                class="mb-4 red--text"
                @click="submitDialoge = false"
                >Back</v-btn
              >

              <v-btn
                text
                width="90px"
                class="mb-4 primary--text"
                :loading="loadingcnfrm"
                @click="confirmorder()"
                v-if="paymenttextshow == 1"
                >Submit</v-btn
              >
              <v-btn
                text
                width="90px"
                    :loading="loadingsubmitbnk"
                class="mb-4 primary--text"
                @click="submitBankFund()"
                v-else
                >Submit</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <page ref="paymentGateway" />
      <OverleyProccessg :overlay="overlay" />

      <v-dialog v-model="paymentDialog" width="800" persistent>
        <v-card class="overflow-hidden">
          <v-toolbar dark dense class="header" flat>
            <v-icon>mdi-bank</v-icon>
            <span class="ml-3">Payment Options</span>
            <v-spacer></v-spacer>
            <v-btn class text dark @click="close()">
              <v-icon color="white" class="subtitle-2" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="ml-n9">
              <v-col cols="12" sm="12" xl="6" lg="6" md="6">
                <v-btn
                  :class="{ grey: activeTab === 'banktransfer' }"
                  width="400px"
                  @click="setActiveTab('banktransfer')"
                >
                  BANK TRANSFER
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" xl="6" lg="6" md="6">
                <v-btn
                  :class="{ orange: activeTab === 'fpx' }"
                  width="400px"
                  @click="setActiveTab('fpx')"
                >
                  FPX
                </v-btn>
              </v-col>
            </v-row>

            <v-card
              height="auto"
              v-if="activeTab === 'banktransfer'"
              class="mt-2"
              outlined
            >
              <v-card-text>
                <v-row class="ml-1">
                  <span
                    justify="center"
                    style="font-size: 13px"
                    align="center"
                    class="black--text"
                    >Please transfer funds from your Company's registered bank
                    account to the following bank account and then submit
                    details</span
                  >
                </v-row>

                <v-row class="ml-1">
                  <span class="grey--text"><b>ACCOUNT NAME</b> : </span>
                  <span class="primary--text">
                    Instapay Technologies Sdn Bhd</span
                  ></v-row
                >
                <v-row class="ml-1">
                  <span class="grey--text"><b>ACCOUNT NUMBER</b> : </span>
                  <span class="primary--text">3230126300</span></v-row
                >
                <v-row class="ml-1">
                  <span class="grey--text"><b>BANK NAME</b> : </span>
                  <span class="primary--text"> Public Bank</span>
                </v-row>

                <v-form ref="fund1Form">
                  <v-row class="ml- mr- mt-4">
                    <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
                      <v-text-field
                        v-model="paymentMode"
                        label=" Payment Mode *"
                        outlined
                        dense
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="8" xl="8" md="8" sm="12" xs="12">
                      <v-select
                        label="Select Bank Name *"
                        :items="listOfBankDetails"
                        v-model="banknamedetails"
                        item-text="name"
                        :hint="searchHint"
                        persistent-hint
                        @input="getHint(banknamedetails)"
                        item-value="bank_details"
                        outlined
                        dense
                        :rules="[(v) => !!v || 'Required']"
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      xl="4"
                      md="4"
                      sm="12"
                      xs="12"
                      class="mt-n3"
                    >
                      <v-text-field
                        v-model="packValue.abilling_fee"
                        maxlength="8"
                        :rules="amountrules"
                        color="primary"
                        label="Amount(RM) *"
                        required
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      lg="4"
                      xl="4"
                      md="4"
                      sm="12"
                      xs="12"
                      class="mt-n3"
                    >
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        color="primary"
                        :return-value.sync="date_of_transaction"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date_of_transaction"
                            dense
                            outlined
                            hint="YYYY/MM/DD"
                            persistent-hint
                            label="Date of Transaction"
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'Required']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="new Date().toISOString().substr(0, 10)"
                          v-model="date_of_transaction"
                          color="primary"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(date_of_transaction)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      xl="4"
                      md="4"
                      sm="12"
                      xs="12"
                      class="mt-n3"
                    >
                      <!-- <v-text-field
                      v-if="item === 'CHEQUE'"
                      v-model="chequenumber"
                      color="primary"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9@._%+-]{0,10}$)[0-9 +-]{0,64}$/.test(
                            v
                          ) || 'Invalid',
                        (v) => (v && v.length < 11) || 'Invalid Check Number',
                      ]"
                      maxlength="10"
                      label="Cheque Number *"
                      required
                      outlined
                      dense
                    ></v-text-field> -->
                      <v-text-field
                        dense
                        v-model="chequenumber"
                        label="Enter Bank Txn ID"
                        outlined
                        :rules="[
                          (v) => !!v || 'Required',
                          (v) =>
                            /^[a-zA-Z0-9]*$/.test(v) ||
                            'Speacial characters not allowed',
                        ]"
                        required
                        maxlength="36"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      lg="12"
                      xl="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="mt-n3"
                    >
                      <v-textarea
                        dense
                        rows="1"
                        outlined
                        label="Remarks *"
                        v-model="comments"
                        :rules="[(v) => !!v || 'Required']"
                      ></v-textarea>
                    </v-col>
                    <!-- <v-col cols="12" md="6" class="mt-n5">
                      <v-file-input
                        v-model="file"
                        clearable
                        label="Upload Document"
                        dense
                        @change="beforeaddingfile()"
                        class="mr-3"
                        outlined
                      >
                      </v-file-input>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-n5">
                      <v-row class="mt-n3">
                        <v-col cols="12">
                          <v-list dense class="mt-n4">
                            <v-list-item
                              v-for="(item, i) in new_array"
                              :key="i"
                              class="mt-n2"
                              dense
                            >
                              <v-list-item-icon class="mr-n2">
                                <v-icon
                                  class="primary--text ml-5 mr-5 mt-2"
                                  x-small
                                  >mdi-circle-slice-8</v-icon
                                >
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="mt-2">
                                  {{ item.fileName }}</v-list-item-title
                                >

                                <v-icon
                                  small
                                  class="mt-n5"
                                  style="margin-left: 80px"
                                  color="red"
                                  @click="deleteItem(item)"
                                  >mdi-close</v-icon
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-col> -->
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions class="mt-n8">
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  rounded
                  class="primary elevation-6 mt-n1 mr-3"
                  medium
                  :loading="loadingSubmit"
                  @click="submitFund()"
                >
                  Submit
                </v-btn>
              </v-card-actions></v-card
            >
            <v-card height="auto" v-if="activeTab === 'fpx'" class="mt-2">
              <v-card-text justify="center" align="center" class="mt-4">
                <v-row justify="center" align="center">
                  <span class="font-weight-bold text"
                    >Enter Amount and Click on Continue for Online Banking.
                  </span>
                </v-row>

                <!-- Remove the v-form from here -->
                <v-row class="mt-8">
                  <v-col lg="12" xl="12" md="12" sm="12" xs="12">
                    <v-text-field
                      v-model="packValue.abilling_fee"
                      label="Amount *"
                      :rules="fpxAmountrules"
                      outlined
                      dense
                      @keypress="isNumber(event)"
                      maxlength="8"
                      @keydown.space="preventLeadingSpace"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  rounded
                  class="primary theme--light elevation-12 mt-n3"
                  medium
                  :loading="loadingSubmit"
                  @click="openEGHLPage('2')"
                >
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import page from "@/Views/Payments/page.vue";
export default {
  components: {
    page,
    OverleyProccessg,
  },
  data: () => ({
    activeTab: "banktransfer",

    paymentModeList: ["BANK TRANSFER", "FPX"],
    tab: null,
    paymentMode: "BANK TRANSFER",
    listOfBankDetails: [],
    searchHint: "",
    banknamedetails: "",
    amountrules: [
      (v) => !!v || "Required",
      (v) =>
        /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9 +-]{0,64}$/.test(v) || "Invalid",
      (v) => (v && v.length < 20) || "Invalid",
    ],
    amount: "",
    date_of_transaction: new Date().toISOString().substr(0, 10),
    modal: false,
    comments: "",
    chequenumber: "",
    loadingSubmit: false,
    loadingcnfrm:false,
    loadingsubmitbnk:false,
    cardorfpxamount: "",
    transectnStatus: 0,
    checkaccessdata: {},
    row: null,
    dialogeSelectCard: false,
    submitDialoge: false,
    packValue: "",
    overlay: false,
    cardpack: [],
    cardpackdata: [],
    coloumn: 5,
    paymenttextshow: "",
    PendingRequestMSg: "",
    packtype: "",
    packs: [
      {
        name: "Pack of 10",
        code: 10,
      },
      {
        name: "Pack of 20",
        code: 20,
      },
      {
        name: "Pack of 50",
        code: 50,
      },
    ],
    orderno: "",
    redirect: false,
    btnloading: false,
    count: 0,
    paymentDialog: false,
  }),
  created() {
    // alert(233);

    // this.getuserdeatils();
    // this.confirmorder();

    // this.$store.getters.get_getCustDetails.funding_balance = 100;
    // this.$store.getters.get_getCustDetails.is_purchase = 1;
    this.checkaccess();
  },
  watch: {
    paymentDialog(val) {
      if (val == true) {
        this.activeTab = "banktransfer";
      }
    },
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getpackmaster();
        this.pendingRequest();
        this.getbankDetails();
      }
    },
    coseSelectCard() {
      this.dialogeSelectCard = false;
      this.row = null;
      this.count = 0;
    },
    getToconTact() {
      this.$router.push("ContactUs");
    },
    submit() {
      this.submitDialoge = true;
    },
    async confirmorder() {
      this.loadingcnfrm = true;
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "REQCARD",
          corp_id: this.$store.getters.get_corpid,
          quantity: this.packValue.no_of_cards,
          card_type: 2,
          pack_id: this.packValue.pack_id,
          amount: this.packValue.abilling_fee,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseDataconfirm", responseData);

      if (responseData.data.status == "00") {
        this.submitDialoge = false;
        this.dialogeSelectCard = false;
        this.overlay = false;
        this.getuserdeatils();
      this.loadingcnfrm = true;

        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
      } else {
        this.dialogeSelectCard = false;
        this.submitDialoge = false;
        this.overlay = false;
      this.loadingcnfrm = true;

        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },

    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var rowlist = responseData.data.data;
          // console.log("getuserdeatils", rowlist.funding_balance);
          this.$store.commit("SET_Cusdetails", rowlist);
        }
        // rowlist.department_count = "1";
        this.overlay = false;
      }
      // console.log("getuserdeatils", responseData);
    },
    async getpackmaster() {
      // alert(20);
      this.overlay = true;
      var inputData = {
        method_name: "CARDS",
        page_no: null,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "GETPACKD",
          pack_type: 1,
        },
      };

      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.cardpack =
          responseData.data.data == null ? [] : responseData.data.data;
        //  console.log(this.cardpack);

        if (responseData.data.data.length == 3) {
          this.coloumn = 3;
        } else {
          this.coloumn = 4;
        }
        this.overlay = false;
      } else {
        this.overlay = false;
      }
    },
    routetofundings() {
      this.$store.commit("SET_dialogcheck", true);
      this.$router.push("/corporatefundrequest");
    },
    getPackdec(value) {
      var retunValue = "";
      this.packs.forEach(function (ele) {
        if (value == ele.code) {
          retunValue = ele.name;
        }
      });
      return retunValue;
    },

    openEGHLPage(value, packdata) {
      // console.log("value", value);
      // console.log(packdata);
      //    console.log(this.$store.getters.get_getCustDetails.is_purchase);
      this.count = 1;
      if (value == 0) {
        this.btnloading = true;
        this.dialogeSelectCard = true;
        this.packValue = packdata;
        // console.log("bb", this.packValue);
        // console.log("aaa", this.$store.getters.get_getCustDetails);
        if (this.$store.getters.get_getCustDetails.is_purchase == 0) {
          this.paymenttextshow = 0;
        }
        if (this.$store.getters.get_getCustDetails.is_purchase != 0) {
          // console.log(packdata.abilling_fee);
          if (
            parseInt(packdata.abilling_fee) >
            parseInt(this.$store.getters.get_getCustDetails.funding_balance)
          ) {
            this.paymenttextshow = 2;
          }
          if (
            parseInt(packdata.abilling_fee) <=
            parseInt(this.$store.getters.get_getCustDetails.funding_balance)
          ) {
            this.paymenttextshow = 1;
          }
        }
        this.btnloading = false;

        //    console.log("this.paymenttextshow", this.paymenttextshow);
      } else if (value == 1) {
        this.paymentDialog = true;
      } else if (value == 2) {
        if (this.packValue.abilling_fee != "") {
          var valuetosend = this.packValue.no_of_cards;
          var valueofpack = this.packValue.abilling_fee;
          var packid = this.packValue.pack_id;

          // if (this.packValue == 10) {
          //   valuetosend = "500.00";
          // } else if (this.packValue == 20) {
          //   valuetosend = "950.00";
          // } else if (this.packValue == 50) {
          valuetosend,
            valueofpack,
            //   valuetosend = "2500.00";
            // }
            // here call function of child comp

            //     console.log("valuetosend", valuetosend);
            //   console.log(" this.packValue,", this.packValue);
            (this.$refs.paymentGateway.redirect = true);

          this.$refs.paymentGateway.getCallfororderId(
            valueofpack,
            valuetosend,
            this.row,
            "2",
            packid
          );
          this.dialogeSelectCard = false;
          this.paymentDialog = false;
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: "Please fill the mandatory field",
            color: "red",
          });
        }
      }
      // this.pendingRequest();
      // this.$refs.paymentGateway.getURL();
    },
    async pendingRequest() {
      // alert(20);
      this.overlay = true;
      var inputData = {
        method_name: "CFUND",
        page_no: null,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "CHECKRE",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("responsdata", responseData)
      this.PendingRequestMSg = responseData.data.status_msg;
      // console.log("responsdata", this.PendingRequestMSg);
    },
    close() {
      this.banknamedetails = null;
      this.chequenumber = null;
      this.amount = null;
      this.comments = null;
      this.searchHint = null;
      this.cardorfpxamount = null;
      this.openpaymentoptions = false;
      this.opencarddialog = false;
      this.paymentDialog = false;
      // this.$refs.fund1Form1.reset();
      // this.$refs.fund1Form.reset();
    },
    async getbankDetails() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BANKGET",
          corp_id: this.$store.getters.get_corpid,
          search_text: this.searchText,
        },
      };
      var responseData = await apiCall(inputData);

      var resList = responseData.data.data;
      resList.forEach((element) => {
        this.listOfBankDetails.push({
          name: element.bank_name,
          bank_details: element,
        });
      });

      // console.log(this.listOfBankDetails);
    },
    getHint(getValue) {
      //    console.log(getValue);
      this.searchHint =
        "Acct Name : " +
        getValue.account_name +
        ", " +
        "Acct No. : " +
        getValue.bank_account_num;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    submitFund() {
      if (this.$refs.fund1Form.validate()) {
        this.submitDialoge = true;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Please fill the required fields",
          color: "red",
        });
      }
    },

    async submitBankFund() {
      // var row = {
      //   acct_type: this.banknamedetails.account_type,
      //   acct_name: this.banknamedetails.account_name,
      //   bank_name: this.banknamedetails.bank_name,
      //   acct_no: this.banknamedetails.bank_account_num,
      // };
      // console.log(row);
      // if (this.$refs.fundForm.validate()) {
      this.loadingsubmitbnk = true;
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CARDBYBANK",
          corp_id: this.$store.getters.get_corpid,
          user_id: this.$store.getters.get_userid,
          amount: this.packValue.abilling_fee,
          card_type: 2,
          packid: this.packValue.pack_id,
          quantity: this.packValue.no_of_cards,
        },
      };

      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.orderno = responseData.data.data[0].order_no;
        this.RequestFunds = false;
        this.loadingsubmitbnk = false;
        this.openpaymentoptions = false;
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.paymentDialog = false;
        this.dialogeSelectCard = false;
        this.submitDialoge = false;
        this.cFund();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.RequestFunds = false;
        this.loadingsubmitbnk = false;
        this.paymentDialog = false;
        this.dialogeSelectCard = false;
      }
      this.close();
    },
    async cFund() {
      var row = {
        acct_type: this.banknamedetails.account_type,
        acct_name: this.banknamedetails.account_name,
        bank_name: this.banknamedetails.bank_name,
        acct_no: this.banknamedetails.bank_account_num,
      };

      this.loadingSubmit = true;
      var inputData = {
        method_name: "CFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CREATE",
          corp_id: this.$store.getters.get_corpid,
          payment_mode: this.paymentMode == "CHEQUE" ? 1 : 2,
          request_type: 1,
          payment_detail: {
            bank_info: row,
            pay_id: this.chequenumber,
            date_of_txn: this.date_of_transaction,
          },
          initiated_by: this.$store.getters.get_userid,
          amount: this.packValue.abilling_fee,
          comments: this.comments,
          fund_type: 1,
          order_no: this.orderno,
        },
      };
      await apiCall(inputData);
    },
    banktransfer() {
      this.changeColor();
      this.cardcount = 0;
    },
    fpx() {
      this.changeColor1();
      this.cardcount = 1;
    },
    setActiveTab(tabName) {
      this.activeTab = tabName;
    },
  },
};
</script>

<style lang="scss">
.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}

.bg {
  background: #1b3249 !important;
}
.grey {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
.orange {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
.btn1 {
  background: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgba(223, 192, 126, 1) 50%,
    rgba(165, 126, 60, 1) 100%
  );
  border: solid 1px #1b3249;
  &:hover {
    background: white;
    color: #000;
  }
  .cursor {
    cursor: pointer;
  }
}
</style>
